import { Box, Button, Typography } from '@mui/material';
import CustomLink from '../custom/custom-link';
import { Rutas } from '@/constants/rutas';
import { useContext, useState } from 'react';
import { Context } from '@/context';
import { Avatar, Divider } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { SUBSCRIPTION_TYPE } from '@/constants/subscription-type';
import PremiumIcon from '../icons/subscriptions/premium';
import LogoutIcon from '../icons/logout-icon';
import { REDUCERS } from '@/constants/reducers';
import UserProfileIcon from '../icons/user-profile-icon';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import NavigationButton from '../navigation/NavigationButton';

const SearchBarUserLogged = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { state, dispatch } = useContext(Context);
    const { user } = state;
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const closeMenu = () => {
        setAnchorEl(null);
    };

    const logout = () => {
        dispatch({ type: REDUCERS.LOGGED_OUT_USER });
    };

    return (
        <>
            {!user.logged ? (
                <CustomLink href={Rutas.INICIA_SESION}>
                    <NavigationButton aria-label="Iniciar sesión">
                        <PersonOutlineOutlinedIcon sx={{ color: '#ccc', width: 25, height: 25 }} />
                    </NavigationButton>
                </CustomLink>
            ) : (
                <>
                    <NavigationButton
                        id="nickname"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                        aria-label="Perfil de usuario"
                    >
                        {user.subscriptionType === SUBSCRIPTION_TYPE.PREMIUM && (
                            <PremiumIcon
                                width={12}
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    right: '0',
                                    zIndex: 1000,
                                }}
                            />
                        )}
                        <Avatar
                            src={`${user.image}?width=45`}
                            alt={user.nickname}
                            sx={{
                                width: 30,
                                height: 30,
                                borderRadius: '50%',
                            }}
                        />
                    </NavigationButton>
                    <Menu id="profile" anchorEl={anchorEl} open={open} onClose={closeMenu}>
                        <CustomLink href={Rutas.PERFIL_DE_USUARIO} passHref>
                            <MenuItem
                                onClick={() => {
                                    closeMenu();
                                }}
                            >
                                <Box style={{ marginRight: '5px' }}>
                                    <UserProfileIcon />
                                </Box>
                                Perfil de usuario
                            </MenuItem>
                        </CustomLink>
                        <Divider style={{ backgroundColor: '#E0E0E0' }} />
                        <CustomLink href={Rutas.SUSCRIPCIONES}>
                            <MenuItem
                                onClick={() => {
                                    closeMenu();
                                }}
                            >
                                <Box style={{ marginRight: '5px' }}>
                                    <PremiumIcon />
                                </Box>
                                {user.subscriptionType === SUBSCRIPTION_TYPE.PREMIUM
                                    ? 'Mi suscripción'
                                    : 'Hazte Premium'}
                            </MenuItem>
                        </CustomLink>
                        <Divider style={{ backgroundColor: '#E0E0E0' }} />
                        <MenuItem
                            onClick={() => {
                                logout();
                            }}
                        >
                            <Box style={{ marginRight: '5px' }}>
                                <LogoutIcon />
                            </Box>
                            <Typography component="span">Cerrar sesión</Typography>
                        </MenuItem>
                    </Menu>
                </>
            )}
        </>
    );
};

export default SearchBarUserLogged;
